<template>
  <div class="wrapper">
    <NavBar></NavBar>
    <MobileManu></MobileManu>

    <transition name="slide" mode="out-in">
      <router-view />
    </transition>

    <FooterView></FooterView>
    <CopyRight></CopyRight>
  </div>
</template>

<script>
  import NavBar from './parsials/navbar.vue';
  import MobileManu from './parsials/mobilemanu.vue';
  import FooterView from './parsials/footer.vue';
  import CopyRight from './parsials/copyright.vue';

  export default {
    components: {
      NavBar,
      MobileManu,
      FooterView,
      CopyRight,
    },

  }

  function toggleSidebar() {
    const sidebar = document.getElementById("sidebar");
    sidebar.classList.toggle("active");
  }
// Run the function on page load and window resize
window.addEventListener('load', adjustContainers);
window.addEventListener('resize', adjustContainers);

function adjustContainers() {
    // Get all elements you want to adjust
    const containers = document.querySelectorAll('.adjustable-container');

    containers.forEach((container) => {
      if (window.innerWidth <= 1024) {
        container.classList.remove('container');
        container.classList.add('container-fluid');
      } else {
        container.classList.remove('container-fluid');
        container.classList.add('container');
      }
    });
  }

  
</script>
<style>
  .slide-enter-from {
    opacity: 0;
    transform: translateX(100px);
  }

  .slide-enter-active {
    transition: all .9s ease-out;
  }

  .slide-leave-to {
    opacity: 0;
    transform: translateX(-100px);
  }

  .slide-leave-active {
    transition: all .7s ease-in;
  }
</style>
